import PropTypes from "prop-types";
import React from "react";

import { RoleShape } from "../../policies/proptypes";
import Loader from "../../shared/components/Loader";
import RoleItem from "./RoleItem";

const RolesList = ({ roles, loading, currentRole, setCurrent }) => {
  const list = loading ? (
    <Loader text="Loading roles..." />
  ) : (
    roles.map(role => {
      const selected = (currentRole && role.$uri === currentRole.$uri) || false;
      return (
        <RoleItem
          role={role}
          key={role.$uri}
          setCurrent={setCurrent}
          selected={selected}
        />
      );
    })
  );

  return (
    <div className="l-roles__column" style={{ gridArea: "roles-list" }}>
      <div className="l-roles__column-header">
        <span className="p-muted-heading u-no-margin--bottom">Roles</span>
      </div>
      <div className="l-roles__column-panel">
        <ul className="p-list">{list}</ul>
      </div>
    </div>
  );
};

RolesList.propTypes = {
  roles: PropTypes.arrayOf(RoleShape).isRequired,
  currentRole: RoleShape,
  loading: PropTypes.bool.isRequired,
  setCurrent: PropTypes.func.isRequired
};

RolesList.defaultProps = {
  currentRole: undefined
};

export default RolesList;
